<template>
<div class="underConstruction">
  <div class="projectName">{{ project.name }}</div>
  <el-tabs type="border-card" @tab-click="tabClick" v-model="active">
    <el-tab-pane v-for="(item, index) in projectTitleList" :key="index" :label="item.title" :name="item.name">
      <div v-if="item.name === '1'">
        <div v-if="list.length === 0 " class="noContent">
          <img src="../../assets/img/public/blank_icon_none.png">
        </div>

        <div v-else>
          <div class="distributionBox" v-for="(item, index) in list" :key="index" @click="detail(item.id)">
            <div class="personInformationBox">
              <div>
                <img class="headImg" src="../../assets/img/paihuo/paihuo_touxiang_default.png"
                     v-if="!item.headImg">
                <img :src="item.headImg" v-else class="headImg" @click.stop="imagePreview(item.headImg)">
              </div>
              <div class="personInformation">
                <div class="name ">{{ item.userinfo }}</div>
                <div class="information">
                  <span>工种： </span>
                  {{ item.typeWorks }}
                </div>
                <div class="information">
                  <span>家庭住址： </span>
                  {{ item.city }}
                </div>
                <div class="information">
                  <span>工作经验： </span>
                  {{ item.workingAge }}
                </div>
                <div class="WRAST" >
                  <span class="text">信用等级 </span>
                  <span class="WRASText" v-if="item.creditStar.socreLevel == -1">黑名单</span>
                  <span class="WRASText" v-if="item.creditStar.socreLevel == 0">信用未评级</span>
                  <img src="../../assets/img/paihuo/star_one.png" class="star_one"
                       v-if="item.creditStar.starCount === 1">
                  <img src="../../assets/img/paihuo/star_two.png" class="star_two"
                       v-if="item.creditStar.starCount === 2">
                  <img src="../../assets/img/paihuo/star_three.png" class="star_three"
                       v-if="item.creditStar.starCount === 3">
                  <img src="../../assets/img/paihuo/star_four.png" class="star_four"
                       v-if="item.creditStar.starCount === 4">
                  <img src="../../assets/img/paihuo/star_five.png" class="star_five"
                       v-if="item.creditStar.starCount === 5">
                </div>
              </div>
            </div>
            <el-button type="primary" class="button btWith_100 btnHeight_40" block @click="deleteWorkers(item.id)"  v-if="isMyRelease == 0 && projectType == '1'">移出项目</el-button>
          </div>
        </div>
        <div class="buttonBox">
          <div v-if="isMyRelease == 0 && projectType == '1' && finishStatus !== 2">
            <!--<el-button type="warning" @click="addPerson" class="btnHeight_40 btWith_120">添加人员</el-button>-->
            <el-button type="primary" @click="applyCompletion" v-if="finishStatus == '0'" class="btnHeight_40 btWith_120 mg_left_40">申请完工</el-button>
          </div>

          <div v-if="isMyRelease == 0 && projectType == 1 && finishStatus == 2">
            <!--<el-button class="btnHeight_40 btWith_120" type="warning" @click="addPerson">添加人员</el-button>-->
            <el-button class="btnHeight_40 btWith_240 mg_left_40" type="primary"  @click="rejectionReasons">
              完工申请被驳回，点击查看
            </el-button>
          </div>

          <div v-if="isMyRelease == 1 && projectType == 1 && status == 5">
            <el-button class="btnHeight_40 btWith_120 " type="warning" @click="applyCompletion">完工</el-button>
          </div>

          <el-button class="btnHeight_40 btWith_120 mg_left_40" color="#46C183" type="success" @click="exportPerson" v-if="unitFlag !== '2'">导出人员</el-button>
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="tabClick"
        />
      </div>
      <div v-else>
        <div class="project-info">
          <template v-if="projectType == '2'">
            <div class="project-info">
              <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
              <projectInfo :project="project"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="0"/>
              <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
              <projectInfo :project="project.oldInfo"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="1" :typeText="'完工'"/>
            </div>
          </template>
          <template v-else-if="(isMyRelease == 0 && finishStatus == '1')&&projectType !== '2'">
            <div class="project-info">
              <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
              <projectInfo :project="project"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="0"/>
              <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
              <projectInfo :project="project.oldInfo"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="1" :typeText="'已经申请完工，请等待'"/>
            </div>
          </template>
          <template v-else>
            <div class="project-info">
              <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
              <projectInfo :project="project"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="0"/>
              <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
              <projectInfo :project="project.oldInfo"  :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="1"/>
            </div>
          </template>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { workersList, getNormalProjectInfo, workersDel, getFinishStatus, completeFinish, finishApply } from '@api/project'
import projectInfo from '@views/components/projectInfo'
export default {
  name: 'underConstruction',
  components: {
    projectInfo
  },
  data () {
    return {
      active: '1',
      projectTitleList: [
        { name: '1', title: '参与人员' },
        { name: '2', title: '项目详情' }
      ],
      list: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      isMyRelease: 0,
      finishStatus: '',
      assessStatus: '',
      id: '',
      status: '',
      projectType: '',
      incomeListLoading: false,
      project: {},
      unitFlag: ''
    }
  },
  created () {
    this.companyId = localStorage.getItem('companyId')
    this.id = this.$route.query.id
    this.isMyRelease = this.$route.query.isMyRelease
    this.projectType = this.$route.query.projectType
    this.status = this.$route.query.status
    this.workersList()
    this.getNormalProjectInfo()
    if (this.isMyRelease == 0 && this.projectType == 1) {
      this.getFinishStatus()
    }
  },
  methods: {
    // 查询参与人员列表
    workersList () {
      this.incomeListLoading = true
      workersList({
        projectId: this.id,
        pageNum: this.pageNum,
        pageSize: 20
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          this.list = res.data.data.rows
          this.total = res.data.data.totalRows
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    tabClick (name) {
      this.pageNum = 1
      this.pageSize = 20
      this.list = []
      this.incomeListLoading = true
      if (this.active === '1') {
        this.workersList()
      } else if (this.active === '2') {
        this.getNormalProjectInfo()
      }
    },
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.$route.query.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    // 获取项目状态
    getFinishStatus () {
      getFinishStatus({ projectId: this.id }).then(res => {
        if (res.data.code === 200) {
          this.finishStatus = res.data.data.finishStatus
          this.finishId = res.data.data.finishId
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    exportPerson () {
      const url = `${process.env.VUE_APP_BASE_API}/project/userExport/${this.$route.query.id}`
      const elemIF = document.createElement('iframe')
      elemIF.src = url
      elemIF.style.display = 'none'
      document.body.appendChild(elemIF)
    },
    // 删除人员
    deleteWorkers (id) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        workersDel({
          projectId: this.$route.query.id,
          userId: id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.tabClick()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    applyCompletion () {
      // 单位标识：0-招标方；1-投标方
      // finishFlag:项目完工标识：0-未申请；1-申请中；2-被驳回;3-申请已通过
      this.$confirm('确认发送完工申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送完工申请
        this.applySubmit()
      })
    },
    applySubmit () {
      if (this.isMyRelease == 1) {
        // 招标方发起完工
        completeFinish({
          projectId: this.$route.query.id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
            this.$router.go(-1)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        // 投标方申请完工
        finishApply({
          projectId: this.$route.query.id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
            this.$router.go(-1)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    rejectionReasons () {

    }
  }
}
</script>

<style scoped lang="scss">
.underConstruction{
  width: 75%;
  .distributionBox{
    position: relative;
  }
  .button{
    position: absolute;
    right: 0;
    bottom: 28px;
  }
  .buttonBox{
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }
}
</style>
